import { render, staticRenderFns } from "./StoreCard.vue?vue&type=template&id=55c0baf2&scoped=true"
import script from "./StoreCard.vue?vue&type=script&lang=js"
export * from "./StoreCard.vue?vue&type=script&lang=js"
import style0 from "./StoreCard.vue?vue&type=style&index=0&id=55c0baf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c0baf2",
  null
  
)

export default component.exports